import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import GamesSearchModal from "../../../components/GamesSearchModal";
import { altGaming } from "../../../../lib/data/altGaming.data";
import BackIcon from "../../../../assets/svg/BackIcon";

const ALTGaming = () => {
  const navigate = useNavigate();
  const categoriesTab = [
    { name: "Voltent", key: "voltentGaming" },
    { name: "ICONIC21", key: "iconic21Gaming" },
    { name: "Turbo Games", key: "turboGaming" },
    { name: "PGSoft", key: "pgsoftGaming" },
    { name: "Booming Games", key: "boomingGames" },
    { name: "Bet Games", key: "betGames" },
    { name: "Play'n Go", key: "playnGoGaming" },
    { name: "Playtech Live", key: "playtechliveGaming" },
    { name: "Smartsoft Gaming", key: "smartsoftGaming" },
    { name: "Jili Gaming", key: "jiliGaming" },
    { name: "Mac88 Gaming Virtual", key: "mac88Gaming" },
  ];
  const [activeCategory, setActiveCategory] = useState("voltentGaming");

  // **Get Games for Active Category**
  const filteredGames = altGaming[activeCategory]
    ? Object.values(altGaming[activeCategory])
    : [];

  console.log("Active Category:", activeCategory);
  console.log("Filtered Games:", filteredGames);

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="prvdr-game-page">
          <div className="d-flex justify-content-between align-items-center PageHeading">
            <h2 className="">ALT Gaming</h2>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>

          {/* CATEGORY TABS */}
          <ul className="tabs mt-3">
            {categoriesTab.map((tab, index) => (
              <li
                key={index}
                onClick={() => {
                  if (tab?.redirectUrl) {
                    navigate(tab?.redirectUrl);
                  } else {
                    setActiveCategory(tab.key);
                  }
                }}
              >
                <a
                  href="#"
                  className={activeCategory === tab.key ? "active" : ""}
                >
                  {tab.name}
                </a>
              </li>
            ))}
          </ul>

          {/* GAMES LIST */}
          <ul className="gamelisting">
            {filteredGames.length > 0 ? (
              filteredGames.map((game, idx) => (
                <li key={"casinogame" + idx}>
                  <a href={game.redirectUrl}>
                    <img src={game.imgUrl} alt={game.alt} />
                    <div className="providerName">{game.providerName}</div>
                    <div className="GameName">{game.name}</div>
                  </a>
                </li>
              ))
            ) : (
              <p>No games available for this category.</p>
            )}
          </ul>
        </div>
      </main>
    </>
  );
};

export default ALTGaming;
